// extracted by mini-css-extract-plugin
export var fadeInOut = "_4n-3";
export var icon = "_4n-4";
export var savedIndicator = "_4n-2";
export var savingIndicator = "_4n-0";
export var spin = "_4n-1";